export default {
  code: 'ja',
  messages: {
    alpha: '{_field_}はアルファベットのみ使用できます',
    alpha_num: '{_field_}は英数字のみ使用できます',
    alpha_dash: '{_field_}は英数字とハイフン、アンダースコアのみ使用できます',
    alpha_spaces: '{_field_}はアルファベットと空白のみ使用できます',
    between: '{_field_}は{min}から{max}の間で指定してください',
    confirmed: '{_field_}が一致しません',
    digits: '{_field_}は{length}桁の数字で指定してください',
    dimensions: '{_field_}は幅{width}px、高さ{height}px以内で指定してください',
    email: 'メールアドレスのフォーマットに誤りがあります',
    excluded: '{_field_}は不正な値です',
    ext: '{_field_}は有効なファイル形式ではありません',
    image: '{_field_}は有効な画像形式ではありません',
    integer: '{_field_}は整数のみ使用できます',
    is: '{_field_}が一致しません',
    length: '{_field_}は{length}文字で指定してください',
    max_value: '{_field_}は{max}以下で指定してください',
    max: '{_field_}は{length}文字以内にしてください',
    mimes: '{_field_}は有効なファイル形式ではありません',
    min_value: '{_field_}は{min}以上で指定してください',
    min: '{_field_}は{length}文字以上で入力してください',
    numeric: '{_field_}は数字のみ使用できます',
    oneOf: '{_field_}は有効な値ではありません',
    regex: '{_field_}のフォーマットが正しくありません',
    required: '{_field_}が未入力です',
    required_if: '{_field_}は必須項目です',
    size: '{_field_}は{size}MB以内で指定してください',
    //カスタムバリデーションメッセージ
    custom_date_between:'{_field_}は{min}から{max}の間で指定してください',
    password:'パスワードで使用できる文字は、「A-Za-z0–9!"#$%&()*+,-./:;<=>?@[]^_`{|}~」です。 数字、小文字、大文字、記号を最低一文字含めた8～32桁の文字列を入力してください',
    decimal: '{_field_}は小数点1桁までで指定してください'


  },
};
